
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_11pcv_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_11pcv_96",
  "sticky-background": "awsui_sticky-background_hyvsj_11pcv_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_11pcv_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_11pcv_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_11pcv_133",
  "drawers-container": "awsui_drawers-container_hyvsj_11pcv_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_11pcv_157",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_11pcv_191",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_11pcv_196",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_11pcv_215",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_11pcv_247",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_11pcv_247",
  "drawer": "awsui_drawer_hyvsj_11pcv_145",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_11pcv_297",
  "drawer-content": "awsui_drawer-content_hyvsj_11pcv_302",
  "drawer-slider": "awsui_drawer-slider_hyvsj_11pcv_307",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_11pcv_314",
  "content": "awsui_content_hyvsj_11pcv_339",
  "layout": "awsui_layout_hyvsj_11pcv_360",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_11pcv_443",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_11pcv_458",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_11pcv_475",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_11pcv_507",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_11pcv_510",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_11pcv_520",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_11pcv_523",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_11pcv_526",
  "has-header": "awsui_has-header_hyvsj_11pcv_526",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_11pcv_547",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_11pcv_547",
  "has-split-panel": "awsui_has-split-panel_hyvsj_11pcv_590",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_11pcv_590",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_11pcv_606",
  "unfocusable": "awsui_unfocusable_hyvsj_11pcv_611",
  "container": "awsui_container_hyvsj_11pcv_621",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_11pcv_646",
  "is-tools-open": "awsui_is-tools-open_hyvsj_11pcv_649",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_11pcv_649",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_11pcv_649",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_11pcv_658",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_11pcv_674",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_11pcv_678",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_11pcv_682",
  "navigation-container": "awsui_navigation-container_hyvsj_11pcv_691",
  "show-navigation": "awsui_show-navigation_hyvsj_11pcv_735",
  "animating": "awsui_animating_hyvsj_11pcv_757",
  "showButtons": "awsui_showButtons_hyvsj_11pcv_1",
  "navigation": "awsui_navigation_hyvsj_11pcv_691",
  "openNavigation": "awsui_openNavigation_hyvsj_11pcv_1",
  "animated-content": "awsui_animated-content_hyvsj_11pcv_819",
  "hide-navigation": "awsui_hide-navigation_hyvsj_11pcv_828",
  "notifications": "awsui_notifications_hyvsj_11pcv_838",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_11pcv_844",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_11pcv_861",
  "position-bottom": "awsui_position-bottom_hyvsj_11pcv_907",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_11pcv_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_11pcv_936",
  "position-side": "awsui_position-side_hyvsj_11pcv_964",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_11pcv_1",
  "tools-container": "awsui_tools-container_hyvsj_11pcv_1001",
  "tools": "awsui_tools_hyvsj_11pcv_1001",
  "openTools": "awsui_openTools_hyvsj_11pcv_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_11pcv_1096",
  "hide-tools": "awsui_hide-tools_hyvsj_11pcv_1106",
  "show-tools": "awsui_show-tools_hyvsj_11pcv_1118",
  "has-tools-form": "awsui_has-tools-form_hyvsj_11pcv_1096",
  "trigger": "awsui_trigger_hyvsj_11pcv_1183",
  "selected": "awsui_selected_hyvsj_11pcv_1222"
};
  